import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'Valentina R.',
  role: 'Diseñadora, 31 años · Córdoba',
  initials: 'VR',
  color: 'bg-purple-500',
  text: 'Empecé el Tomo 02 con desconfianza. Tres días después detecté algo que no cerraba en lo que me decía mi pareja. Apliqué el protocolo y en una semana tuve la claridad que necesitaba. Vale cada peso.'
}, {
  name: 'Marcos D.',
  role: 'Gerente comercial, 38 años · Buenos Aires',
  initials: 'MD',
  color: 'bg-blue-500',
  text: 'Lo apliqué en una negociación complicada. Leí el momento exacto en que el cliente estaba listo para cerrar, sostuve el silencio y la postura. Firmó. Estas herramientas son reales.'
}, {
  name: 'Luciana F.',
  role: 'Estudiante universitaria, 29 años · Mendoza',
  initials: 'LF',
  color: 'bg-pink-500',
  text: 'El Tomo 05 me cambió la vida. Reconocí el patrón de manipulación de alguien que tenía muy cerca antes de caer de nuevo. Si lo hubiera leído dos años antes me habría ahorrado mucho daño.'
}, {
  name: 'Sebastián G.',
  role: 'Emprendedor, 27 años · CABA',
  initials: 'SG',
  color: 'bg-green-500',
  text: 'El bono del Semáforo del Deseo solo ya justifica la compra. Ya no pierdo tiempo ni energía con señales confusas. Leo el interés real y actúo en consecuencia. Brutal.'
}, {
  name: 'Carolina M.',
  role: 'Abogada, 43 años · Rosario',
  initials: 'CM',
  color: 'bg-red-500',
  text: 'Trabajo leyendo personas todos los días y este pack me dio herramientas que ningún libro académico me dio. El protocolo de interrogatorio suave es oro puro para entrevistas.'
}, {
  name: 'Diego P.',
  role: 'Vendedor inmobiliario, 44 años · Santa Fe',
  initials: 'DP',
  color: 'bg-orange-500',
  text: 'En mi trabajo leer al cliente es todo. Desde que aplico el Tomo 06 cierro más, discuto menos y proyecto una presencia completamente distinta. Mis colegas me preguntan qué cambié.'
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 bg-deep-black border-t border-white/5" data-id="element-251">
      <div className="max-w-7xl mx-auto" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-253">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-254">
            Lo que dicen quienes ya lo tienen
          </h2>
          <p className="text-xl text-smoke/80" data-id="element-255">
            Más de 4.800 lectores en Argentina y Latinoamérica
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-256">
          {testimonials.map((test, index) => <div key={index} className={`animate-fade-in-up stagger-${index + 1} bg-[#141414] border border-white/5 p-8 rounded-2xl flex flex-col`} data-id="element-257">
              <div className="flex items-center gap-4 mb-6" data-id="element-258">
                <div className={`w-12 h-12 rounded-full ${test.color} flex items-center justify-center text-white font-bold text-lg`} data-id="element-259">
                  {test.initials}
                </div>
                <div data-id="element-260">
                  <h4 className="font-bold text-white" data-id="element-261">{test.name}</h4>
                  <p className="text-xs text-smoke/60" data-id="element-262">{test.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4" data-id="element-263">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-264" />)}
              </div>

              <p className="text-smoke/90 leading-relaxed flex-1" data-id="element-265">
                "{test.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}